
<!--此页面为显示 没有购买课程-->
<template>

  <div class="box">
    <div style="height: 5%;">
<!--      111-->
    </div>
    <div class="box1">
      <div style="height: 3%">
<!--        222-->
      </div>
      <div class="box2">
        <div class="title">
          巧手智心 stem课
        </div>
        <form v-model="loginForm" class="loginform">
<!--          <div class="logoImg">-->
<!--            <img src="../assets/logo_y.gif"  width="100%">-->
<!--          </div>-->


          <div >
<!--            <div style="z-index: 99999;">-->
<!--              <img src="../assets/user1.jpg"  width="38px">-->
<!--            </div>-->
            <input class="input usernameInput "  type="text" name="username" v-model="loginForm.username"  placeholder="用户名" @blur="changeVal"><br>
          </div>


          <div>
<!--            <div style="z-index: 99999;">-->
<!--              <img src="../assets/pwd1.jpg" class="" width="38px">-->
<!--            </div>-->
            <input class="input passwordInput" type="password" name="password" v-model="loginForm.password" placeholder="密码" @blur="changeVal"><br>


          </div>

          <div style="text-align: center;color: black;font-size: 15px;font-family: myMind" class="tip">{{tip}}</div>

          <div style="display: flex;flex-direction: row;width: 80%;margin: auto">
            <div style="width: 45%;">
              <input class="button" type="button" value="登陆" @click="login">
            </div>
            <div style="width: 45%;margin-left: 10%">
              <input class="button" type="button" value="注册" @click="register">
            </div>
          </div>

          <div style="padding-top: 20px;text-align: center;margin-top: 20px;">
            <span style="cursor: pointer;font-family: myMind;color: cornflowerblue;margin-left: -30px;" @click="login">短信验证码登陆</span>
            <span style="cursor: pointer;font-family: myMind;color: cornflowerblue;margin-left: 20px;" @click="login">忘记密码</span>
          </div>

        </form>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  import jwt from 'jsonwebtoken';
  export default {
    name: "ForgetPwd",
    data:function(){
      return{
        loginForm:{
          username:'',
          password:''
        },
        tip:' ',
      }
    },
    mounted() {

      window.screen.height;
      console.log('%c 窗口像素高：'+window.screen.height+' '+window.screen.availHeight+' '+window.document.documentElement.clientHeight,'color:red');
      document.body.style.height=window.document.documentElement.clientHeight;

    },
    methods:{
      login(){
        axios.post(this.GLOBAL.serverURL+'api/login/',{
          username:this.loginForm.username,
          password:this.loginForm.password
        })
          .then(res=>{
            if(res.data.ret=='1000'){
              this.GLOBAL.token =res.data.token;  //将token存入全局变量中

              this.GLOBAL.userId =jwt.decode(res.data.token).id;

              //在IE 浏览器使用window.localStorage会报错
              window.localStorage.setItem('token',res.data.token);   //将token存入浏览器localStorage
              window.localStorage.setItem('username',jwt.decode(res.data.token).username); //将解码后的用户信息存入浏览器localStorage
              window.localStorage.setItem('id',jwt.decode(res.data.token).id); //将解码后的用户信息存入浏览器localStorage

              this.$router.push("/home");  //进入课程页
            }else{
              this.tip='用户名或密码错误!';

            }
          })
          .catch(err=>{
            console.log('%c catch...','color:red;font-size:15px;');
            console.log(err);
          })
          .finally(res=>{

          });
      },

      changeVal(){
        this.tip='';
      },

      register(){
        this.$router.push('/register')
      }


    },
  }
</script>

<style scoped>

  @import "../assets/fonts/font.css";
  .box{
    background-image: linear-gradient(90deg, rgba(33, 44, 51, 0.3) 8%, rgba(114, 195, 204, 0.5) 8%), linear-gradient(rgba(138, 145, 147, 1) 8%, rgba(114, 195, 204, 0.5) 8%);
    background-size: 60px 60px;
    width: 100%;
    height: 100%;

  }


  .box1{
   width: 90%;
    height: 86%;
    background-color: #ffffff;
    /*position: fixed;*/
    /*top: 5%;*/
    /*margin-left: 5%;*/
    /*margin-right: 5%;*/
    border-radius: 50px;
    border: black solid 0px;
    border-left: black solid 18px;
    border-top: black solid 18px;
    margin: auto;
  }

  .box2{
    width: 95%;
    height: 93%;
    background-color: #f5d13b;
    /*position: fixed;*/
    /*top: 10%;*/
    /*margin-left: 3%;*/
    /*margin-right: 5%;*/
    border-radius: 50px;
    border: black solid 5px;
    border-bottom: black solid 13px;
    border-right: black solid 13px;
    margin: auto;
  }

  .title{
    font-family: myMind;
    padding-top: 40px;
    font-size: 50px;
  }
  .loginform{
    /*position: fixed;*/
    /*width: 60%;*/
    /*left: 27%;*/
    /*top: 31%;*/
    /*border: black solid 3px;*/
    margin: auto;
  }
  .logoImg{
    position: fixed;
    left: 20%;
    top: 25%;
    width: 20%;
  }

  .userImg{
    position: fixed;
    left: 50%;
    top: 20%;
    z-index: 999;
  }
  .username{
    position: fixed;
    left: 50%;
    top: 20%;
  }

  .pwdImg{
    position: fixed;
    left: 50%;
    top: 35%;
    z-index: 999;
  }
  .password{
    position: fixed;
    left: 50%;
    top: 35%;
  }
  .loginBtn{
    position: fixed;
    left: 50%;
    top: 55%;
  }

  .tip{
    margin-top: 20px;
  }
  .input{

    outline: 0;
    border: 1px solid rgba(255, 255, 255, 0.8);
    background-color: rgba(255, 255, 255, 0.7);
    width: 80%;
    border-radius: 30px;
    padding: 10px 15px;
    margin: 0 auto 10px auto;
    display: block;
    text-align: center;
    font-size: 18px;
    color: black;
    -webkit-transition-duration: 0.25s;
    transition-duration: 0.25s;
    font-weight: 300;
    font-family: myMind;

  }
  .button{

    outline: 0;
    border: 1px solid rgba(85, 85, 87, 0.5);
    background-color: rgba(255, 255, 255, 0.3);
    width: 100%;
    border-radius: 30px;
    padding: 10px 15px;
    /*margin: 0 auto 10px auto;*/
    display: block;
    text-align: center;
    font-size: 18px;
    color: black;
    -webkit-transition-duration: 0.25s;
    transition-duration: 0.25s;
    font-weight: 800;
    font-family: myMind;
  }



  .usernameInput{
    background-image: url("../assets/user1.jpg");
    background-position: 15px 6px;
    background-size: 30px;
    background-repeat: no-repeat;

  }

  .passwordInput{
    background-image: url("../assets/pwd1.jpg");
    background-position: 15px 6px;
    background-size: 30px;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 600px) {
    body {
      background-color:lightblue;
    }
    .title{
      font-size: 10px;
      display: none;
    }
    .input{
      width: 80%;
    }
    .loginform{
     width: 100%;
      margin-top: 20%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ForgetPwd.vue